import { render } from "./AListItemSubtitle.vue?vue&type=template&id=2d523107"
import script from "./AListItemSubtitle.vue?vue&type=script&lang=js"
export * from "./AListItemSubtitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__